import { cart } from 'core';
import { Cta } from 'ui/components';
import { useCommand } from 'core/use-cases/utilities';
import { actions } from 'core/use-cases/cart';

export const CartCta = () => {
  const canSubmit = cart.hooks.useCartPropertyByKey('canSubmit');
  const { dispatchCommand } = useCommand();

  const handleOnClick = () => {
    dispatchCommand(actions.giftsFlowCheck());
  };

  return <Cta disabled={!canSubmit} onClick={handleOnClick} />;
};
